import React, { useRef, useEffect } from 'react';
import lottie from 'lottie-web';
import { LOGO_LOADER_SIZE } from '../../../constants';

export const LogoLoader = ({ size = LOGO_LOADER_SIZE.MEDIUM }) => {
    const containerRef = useRef(null);

    useEffect(() => {
        lottie.loadAnimation({
            path: '/static/animations/logoAnimation.json',
            loop: true,
            autoplay: true,
            renderer: "svg",
            container: containerRef.current
        });
    }, []);
    
    return (
        <div style={{ width: size, height: size, margin: '0 auto' }} ref={containerRef}></div>
    );
}


// WEBPACK FOOTER //
// ./src/components/UI/Loader/LogoLoader.js